import pic from '@/utils/pic'
const {
  icon1,
  icon2,
  icon3,
  langzh,
  langen,langno,
  langtw,
  langjp,
  langxby,
  langit,
  langdy,
  langfy,
  langhy,
  langty,
  langyn,
  zhsz,
  jtrz,
  sfrz,
  iconchecked,
  iconcheck,
  icon1_01,
  icon1_02,
  icon1_03,
  icon1_04,
  banner01,
  banner02,
  banner03
} = pic

export default {
  currency: {
    bb: '币币交易',
    bba: '币币账户',
    hy: '合约交易',
    jg: '交割合约',
    hya: '合约账户'
  },
  index: {
    h24: '24H量',
    header_title: ['数字资产交易就选 ' + window.GLOBAL.LANG_TITLE.zh],
    header_small_title: '完整的一站式区块链数字资产交易',
    header_msg: '安全 - 稳定 - 可信',
    register_title: '注册一个 ' + window.GLOBAL.LANG_TITLE.zh + ' 全球站账号 开始交易旅程',
    register_pl: '请输入你的邮箱或手机',
    register: '注册',
    featureTitleWhy: '为什么选择我们',
    featureTitle: '安全 · 稳定 · 可靠',
    featureMsg: '',
    featureList: [{
        icon: icon1,
        title: '安全的钱包技术',
        msg: ['冷、热钱包技术由全球顶级的安全团队开发，从未发生过丢币事件。', '']
      },
      {
        icon: icon2,
        title: '丰富的加密资产业务',
        msg: ['支持现货和多种衍生品交易等，是您的进入加密资产世界的贴身管家。', '']
      },
      {
        icon: icon3,
        title: '分布在世界各地的客户',
        msg: ['为全球超过130个国家或地区用户，提供加密资产的全方位服务。', '']
      }
    ],
    bannerList: [{
        icon: banner01,
        title: "致力于提供业内 领先安全和稳定性",
        msg: ["智能合约保障投资人资产安全", "交易绩效真实", "24h服务保障"]
      },
      {
        icon: banner02,
        title: "我想通过简单操作立即买进卖出",
        msg: ["简单的交易画面", "立即反映在您的账户余额中", "大多数加密货币都可以交易"]
      },
      {
        icon: banner03,
        title: "我想通过交割合约交易积极赚取利润",
        msg: ["开户同时可用", "大量交易期货的战略投资", "一年 365 天，一天 24 小时都可以交易，即使在周末也是如此"]
      }
    ],
    featureList2: [{
        icon: icon1_01,
        title: "透明开放",
        msg: ["运用区块链与智能合约的特性，将交易绩效真实上链，并使用智能合约保障投资人资产安全", ""]
      },
      {
        icon: icon1_02,
        title: "智能投资",
        msg: ["经由顶尖的量化交易专家所提供的多样化策略，任您自由选择", ""]
      },
      {
        icon: icon1_03,
        title: "风险分级",
        msg: ["依据各投资人不同风险与资产管理偏好设计出多元化的投资产品，有效消除投资门槛", ""]
      },
      {
        icon: icon1_04,
        title: "产品多元",
        msg: ["提供各类型用户投资需求及弹性的平台机制，持续产出优于市场的创新金融服务", ""]
      }
    ],
    featureTitle2: '随时随地 多平台终端交易',
    featureMsg2: '覆盖iOS、Android多个平台，支持全业务功能',
    tab: ['主流币', '24H 涨幅榜'],
    thead: ['名称', '最新价格', '当日最高价', '当日最低', '涨幅榜', '24H成交量', '操作'],
    more: '查看更多 >',
    btn: '交易',
    dealsTitle: '一站式交易服务',
    dealsTab: [{
        title: '币币交易',
        content: '币币交易是针对数字资产之间的兑换，以USDT作为计价单位去购买其他币种 。' + window.GLOBAL.LANG_TITLE.zh +
          '币币交易支持比特币、以太坊、莱特币等数字资产实时交易。',
        src: '/static/image/deals-1.jpg',
        path: ''
      },
      {
        title: '合约交易',
        content: '一种数字货币的金融衍生品，不仅支持选择买多或卖空合约来赚取收益，而且操作简单，永不到期。' + window.GLOBAL.LANG_TITLE.zh +
          '合约具有先进的风险管理系统，杠杆最高可达100倍。',
        src: '/static/image/deals-2.jpg',
        path: ''
      }
    ]
  },
  market: {
    tab: ['自选', '合约', '币币'],
    thead: ['币种', '最新价', '24H涨跌幅', '24H最低', '24H最高', '24H成交量', '操作'],
    nodata: '暂无数据'
  },
  footer: {
    p: '©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
    dd: [{
        dt: "关于我们",
        dd: [{
          title: "公司简介",
          id: 1
        }, {
          title: "帮助中心",
          type: 'help'
        }]
      },
      {
        dt: "用户支持",
        dd: [{
            title: "用户协议",
            id: 3
          },
          {
            title: "隐私条款",
            id: 5
          }
        ]
      },
      {
        dt: "联系我们",
        icon: true
      }
    ]
  },
  nav: {
    btn: ["登录", "注册", "资产管理", "下载APP"],
    nav: [{
        title: "首页",
        path: "/index",
        name: 'index'
      },
      {
        title: "行情",
        path: "/market",
        name: 'market'
      },
      // { title: "币币交易", path: "/deal", name: 'deal'},
      // { title: "合约交易", path: "/deal_c", name: 'deal_c' },
      {
        title: "交割合约",
        path: "/deal_jg",
        name: 'deal_jg'
      },
      {
        title: "持仓返利",
        path: "/profit_index",
        name: 'profit_index'
      }
    ],
    nav2: [{
      title: "我的资产",
      path: "/asset"
    }],
    menus: [{
        icon: langzh,
        title: "用户中心",
        path: "/setting"
      },
      {
        icon: langen,
        title: "退出登录"
      }
    ],
    lang: [{
        icon: langen,
        lang: "English",
        key: 'en'
      },
      {
        icon: langno,
        lang: "Norsk",
        key: 'no'
      },
      {
        "icon": langit,
        "lang": "Italiano",
        "key": "it"
      },
      {
        icon: langxby,
        lang: "España",
        key: 'es'
      },
      {
        icon: langfy,
        lang: "français",
        key: 'fr'
      },
      {
        icon: langdy,
        lang: "Deutsche",
        key: 'de'
      },
      {
        icon: langjp,
        lang: "日本語",
        key: 'jp'
      },
      {
        icon: langhy,
        lang: "한국어",
        key: 'kr'
      },
      {
        icon: langty,
        lang: "ไทย",
        key: 'th'
      },
      {
        icon: langyn,
        lang: "Tiếng Việt",
        key: 'vn'
      },
      {
        icon: langzh,
        lang: "简体中文",
        key: 'zh'
      },
      {
        icon: langtw,
        lang: "繁體中文",
        key: 'tw'
      },
    ]
  },
  download: {
    "xz": "下载"
  },
  // 登录
  login: {
    login: '欢迎登录',
    msg: '请输入您已注册的账号',
    list: ['手机/邮箱', '密码', '忘记密码?', '登录', '没有账号，立即注册'],
    message: '账号或密码不能为空'
  },
  register: {
    dl: ['手机注册', '邮箱注册'],
    title: '注册账号',
    country: '国籍',
    country_info: '国籍信息注册后不可修改，请务必如实选择',
    account: '账号',
    code_text: '请输入验证码',
    code_btn: '获取验证码',
    code_unit: 's',
    code_no_data: '验证码不能为空',
    password_text: '请输入密码',
    password_again_text: '请再次输入密码',
    pid_text: '邀请码',
    pid_pl: '选填',
    invitation_code_no_data: '邀请码必填',
    xy: '用户协议',
    xy_no_checked: '请选择协议',
    agree: '我已阅读并同意',
    register_btn: '注册',
    bz: ['国籍信息注册后不可修改，请务必如实选择。', '验证邮件可能会被误判为垃圾邮件，请注意查收。', '请妥善保存您的' + window.GLOBAL.LANG_TITLE.zh + '账号及登录密码。',
      '请勿和其他网站使用相同的登录密码。'
    ],
    account_no_data: '账号不能为空',
    code_no_equality: '验证码不相等',
    password_no_data: '密码不能为空',
    password_no_equality: '两次密码不相等'
  },
  // 设置密码
  bindmpwd: {
    title: '设置密码',
    account: '账号',
    code_text: '请输入验证码',
    code_btn: '获取验证码',
    code_unit: 's',
    password_text: '请输入密码',
    password_again_text: '请再次输入密码',
    code_no_data: '验证码不能为空',
    code_no_equality: '验证码不相等',
    password_no_data: '密码不能为空',
    password_no_equality: '两次密码不相等',
    bindmpwd_btn: '确认',
    phone_no_data: '手机号码不能为空',
    password_login_text: '请输入登录密码',
    password_trade_text: '密码长度6位数字',
    password_again_tarde_text: '密码长度6位数字',
  },
  // 忘记密码
  forgetpwd: {
    title: ['修改密码', '忘记密码'],
    account: '账号',
    code_text: '请输入验证码',
    code_btn: '获取验证码',
    code_unit: 's',
    password_text: '请输入密码',
    password_again_text: '请再次输入密码',
    phone_no_data: '手机号码不能为空',
    account_no_data: '账号不能为空',
    code_no_data: '验证码不能为空',
    code_no_equality: '验证码不相等',
    password_no_data: '密码不能为空',
    password_no_equality: '两次密码不相等',
    forgetpwd_btn: '确认'
  },
  // 绑定手机号码
  bindphone: {
    title: '绑定手机号码',
    phone_text: '手机号',
  },
  person: {
    more: '加载更多',
    no_more: '没有数据了',
    index_center: "用户中心",
    index_menus: [{
        icon: zhsz,
        title: "账户管理",
        path: '/setting'
      },
      {
        icon: sfrz,
        title: "身份验证",
        path: '/sfyz'
      },
      {
        icon: sfrz,
        title: "初级认证",
        path: '/smauth'
      },
      {
        icon: jtrz,
        title: "高级认证",
        path: '/seniorauth'
      },
      {
        icon: jtrz,
        title: "地址认证",
        path: '/dzrz'
      },
      {
        icon: jtrz,
        title: "快捷买币",
        path: '/kjmbSelect'
      },
      {
        icon: jtrz,
        title: "信用分",
        path: '/credit'
      },
      {
        icon: jtrz,
        title: "账户记录",
        path: '/deallog'
      },
      {
        icon: jtrz,
        title: "充币记录",
        path: '/cbjl'
      },
      {
        icon: jtrz,
        title: "提币记录",
        path: '/tbjl'
      },
      //  { icon: jtrz, title: "我的消息", path: '/news' }
    ],
    cbtb: '充币提币',
    jymx: '交易明细',
    xyf: {
      'title': '信用分',
      'pgsj': '评估时间'
    },
    smrz: {
      title: '实名认证',
      sure_title: '您已通过实名认证',
      zj_type: '证件类型',
      zj_info: ['1、认证信息一经验证不可修改，请务必如实填写', '2、被认证的实名信息不能重复认证'],
      zj_name: '姓名',
      zj_num: '证件号码',
      zj_btn: '确定',
      zj_rebtn: '重新验证',
      zj_sebtn: '高级验证',
      zj_type_array: [{
        name: '身份证',
        type: 'idcard'
      }],
      idCardArr: [{
          id: 1,
          name: "身份证"
        },
        {
          id: 2,
          name: "护照"
        },
        {
          id: 3,
          name: "驾驶证"
        },
        {
          id: 4,
          name: "居留证"
        },
        {
          id: 5,
          name: "其它"
        }
      ],
      zj_data: {
        city: '国籍不能为空',
        type: '证件类型不能为空',
        name: '姓名不能为空',
        zj_num: '证件号码不能为空'
      },
      zsxm: '真实姓名',
      qsrzsxm: '请输入真实姓名',
      zjlx: '证件类型',
      qxzzjlx: '请选择证件类型',
      sfz: '身份证',
      zjhm: '证件号码',
      qsrzjhm: '请输入证件号码',
      sczjz: '上传证件照',
      zjzm: '上传证件正面照',
      zjfm: '上传证件背面照',
      qsczjzm: '请上传证件正面照',
      qsczjfm: '请上传证件背面照',
      scqmz: '上传证件与个人签名照',
      qscscqmz: '请上传证件与个人签名照',
      zj: [{
          id: 1,
          title: '身份证'
        },
        {
          id: 2,
          title: '护照'
        },
        {
          id: 3,
          title: '其他'
        },
      ],
      tj: '提交',
      shz: '审核中',
      shtg: '审核通过'
    },
    gjrz: {
      title: '高级认证',
      zj_info: ['1、支持小于8M的JPG、JPEG或PNG格式图片。', '2、证件照片要求清晰，不允许任何修改和遮挡，必须能看清人像、证件号和姓名。',
        '3、照片需免冠，建议未化妆，手持证件人的五官清晰可鉴，完整露出手臂'
      ],
      zj_img: ['/static/image/User_Center_Front_view.png', '/static/image/User_Center_Back_Shot.png',
        '/static/image/User_Center_Full_picture.png'
      ],

    },
    zhgl: {
      title: '安全设置',
      bind: [{
        bind_title: '重置密码',
        bind_name: '邮箱'
      }, {
        bind_title: '设置交易密码',
        bind_name: '邮箱'
      }]
    },
    wdtg: {
      own_code: '专属邀请码',
      own_code_url: '专属邀请连接',
      own_push_title: '我的推广',
      own_push_content: ['邀请总收入（估值）', '邀请人数', '人'],
      own_push_content_profit: ['一级邀请收益', '二级邀请收益', '三级邀请收益', '四级邀请收益'],
      own_push_content_num: ['一级邀请人数', '二级邀请人数', '三级邀请人数', '四级邀请人数'],
      own_push_profit_title: ['ID', '收益', '备注信息', '添加时间'],
      own_push_num_title: ['ID', '名称', '电话', '添加时间'],
    },
    jyzt_td: ['时间', '详情', '金额'],
    cbjl_td: ['时间', '币种', '数量', '状态'],
    sfrz_txt: ['身份认证', '您已经提交审核请等待结果', '您已通过高级认证', '身份证正面', '身份证反面', '认证', '认证失败，请重新认证'],

    zhsz_txt: ['您的账号安全等级: #', '您的账号安全等级: #，完善更多资料，保证账号安全'],
    zhsz_m: '强',
    zhsz_n: '弱',
    zhsz_p: '不安全',
    zhsz_detailList: [
      // { icon: iconchecked, title: '我的邀请码', value: '', btn: '复制邀请码', class: 'copy', event: 'copy' },
      // { icon: '/static/image/User_Center-email.png', title: '邮箱', value: '用于登录、提币、安全设置时使用', value2:'',btn: '绑定', btn2: '已绑定', path2: '/bindphone' },

      // { icon: '/static/image/User_Center-phone.png', title: '手机', value: '用于提现，修改密码，安全设置时用以收取验证短信', value2:'', btn: '绑定', btn2: '已绑定', path2: '/bindphone' },
      {
        icon: '/static/image/User_Center-password.png',
        title: '登录密码',
        value: '互联网账号存在被盗风险，建议您定期更改密码以保护账号安全。',
        value2: '',
        btn: '修改',
        bind_email: '请先绑定邮箱或者手机',
        path: '/forgetpwd?type=changepwd'
      },
      {
        icon: '/static/image/User_Center-password.png',
        title: '交易密码',
        value: '设置密码',
        btn: '去设置',
        path: '/bindmpwd'
      }
    ],
    sksz_txt: ['收款设置', '保存'],
    sksz_list: [{
        label: "用户名:",
        pl: "请输入用户名",
        key: "name"
      },
      {
        label: "开户行名称:",
        pl: "请输入开户行名称",
        key: "bank_name"
      },
      {
        label: "银行卡号:",
        pl: "请输入银行卡号",
        key: "bank_number"
      },
      {
        label: "支付宝账号:",
        pl: "请输入支付宝账号",
        key: "alipay_account"
      },
      {
        label: "微信昵称：",
        pl: "请输入微信昵称",
        key: "weixin_nickname"
      },
      {
        label: "微信账号：",
        pl: "请输入微信账号",
        key: "weixin_account"
      }
    ]
  },
  pasination: {
    first: '首页',
    prev: '上一页',
    next: '下一页',
    last: '尾页',
    no_data: '暂无数据',
  },
  asset: {
    title: '我的资产',
    zjhz: '资金划转',
    cb: '充币',
    gz: 'USDT估值',
    atnv: [],
    zh_title: '总资产折合：',
    index_title: '资产',
    address_title: '币种',
    address_txt: ['请选择', '提币地址', '请输入内容', '备注', '地址列表'],
    address_btn: ['添加', '保存', '删除', '编辑'],
    address_td: ['币种', '提币地址', '备注', '操作'],
    currency_td: ['币种', '可用', '冻结', '折合'],

    table_title: '总资产：',
    table_address_title: '提币地址管理',
    table_td: ['币种', '可用', '冻结', '折合', '操作'],
    table_btn: ['充币', '提币', '记录', '划转'],

    money_text: ['提币地址', '请选择', '数量', '可用：', '手续费',
      '到账数量', '交易密码', '标签(Memo)', '最低提币 '
    ],
    money_btn: '提币',
    xzbz: '选择币种',
    money_msg: ['温馨提示', '1.提币时间为香港时间12:00-24:00，每日可提交2次提币申请（最低提币100u，最高提币20万u）;', '2.目前提币只支持USDT币种，钱包链接类型选择ERC20;',
      '3.提交提币申请后，该笔资金属于冻结状态是因为提现正在进行中，该笔资金暂时由系统托管，不能由您自由支配。并不代表您损失了这笔资产或资产出现异常。请耐心等待中获得批准;',
      '4.提交提币申请后到账时间以区块确认时间为准，如预计提币时间后未到账请咨询咨询客服查询；', '5.为防止套现行为，需累计消费总金额的90%才能发起提币'
    ],
    recharge_title: '充值地址',
    recharge_btn: ['复制', '二维码', '充币'],
    recharge_text: ['数量', '温馨提示', '请勿向上述地址充值任何非USDT资产，否则资产将不可找回。',
      'USDT充币仅支持simple send的方法，使用其他方法（send all）的充币暂时无法上账，请您谅解。', '凭证', '凭证描述(选填)', '链名称'
    ],
    record_title: '财务记录',
    record_td: ['数量', '记录', '时间'],
    transfer_title: '划转',
    transfer_btn: ['全部', '转账'],
    transfer_text: ['从', '至', '请输入划转数量', '可用：'],
    "bq": "标签(Memo)",
    "qsrbq": "请输入标签",
    "yhktx": "银行卡提现",
    "yhmc": "银行名称",
    "qsryhmc": "请输入银行名称",
    "yhzh": "银行账号",
    "qsryhzh": "请输入银行账号",
    "gjhkdm": "国际汇款代码",
    "qsrgjhkdm": "请输入国际汇款代码",
    "yhdz": "银行地址",
    "qsryhdz": "请输入银行地址",
    "skrxm": "收款人姓名",
    "qsrskrxm": "请输入收款人姓名",
    "skrdh": "收款人电话",
    "qsrskrdh": "请输入收款人电话",
    "skrdz": "收款人地址",
    "qsrskrdz": "请输入收款人地址"
  },
  text: {
    btn: '返回',
    login: '请先登录'
  },
  deal: {
    chooseType: '委托类型',
    choose: '请选择',
    balance: '余额：',
    account: ['账户', '可用', '/冻结', '划转'],
    dir: ['买', '卖'],
    dir2: ['可买', '可卖'],
    cs: '自选',
    sxf: '手续费',
    jye: '交易额',
    sc_list: ['市场', '名称', '涨幅'],
    sc_h: ['当前价格', '24H最低价', '24H最高价', '24H成交量'],
    td_lt: ['币种', '最新价', '涨幅'],
    k_line_txt: ['≈', '', '涨幅', '最高价', '最低价', '24H量'],
    tabListLTitle: ["当前委托", "历史委托"],
    tabListLEntrust: ["买入", "卖出"],
    tabListRTitle: ["限价交易", "市价交易"],
    table_btn: ['撤单'],
    index_td_l: ['时间', '交易对象', '数量', '价格', '操作'],
    index_td_r: ['最新价', '方向', '价格', '数量'],
    index_td_r2: ['最新交易', '时间', '价格', '交易量'],
    table_txt: ['已完成', '已撤单'],
    db_1_txt: ['可用', '买入价', '卖出价', '买入量', '卖出量', '交易额', '以市场最优价格买', '以市场最优价格卖', '买入手', '卖出手'],
    db_2_txt: ['价格', '杠杆', '请选择', '手数', '一手 = ', '手', '合约市值', '保证金', '以市场最优价格买', '以市场最优价格卖'],
    pathList: ['合约记录', '交易记录'],
    db_btn: ['买入(做多)', '卖出(做空)'],
    tabListLTitle2: ['当前委托'],
    lt_btn: ['一键平仓', '设置止盈止损价', '平仓', '立即提交', '返回'],
    lt_txt: ['风险率：', '持仓总盈亏：'],
    lt_td: ['类型', '杠杆倍数', '持仓价', '当前价', '保证金', '止盈价', '止损价', '开仓时间', '手数', '盈亏', '操作'],
    lt_dl: ['设置止盈止损价', '止盈价', '止损价'],
    lt_0_btn: ['撤单'],
    lt_0_td: ['联系方式', '币种', '数量', '当前价', '手续费', '操作'],
    lt_1_btn: ['平仓'],
    lt_1_txt: ['平仓中'],
    lt_1_td: ['类型', '持仓价', '当前价', '保证金', '止盈价', '止损价', '开仓时间', '手续费', '盈亏', '操作'],
    node_data: '暂无数据',
    lt_3_txt: ['已平仓', '爆仓'],
    lt_3_td: ['类型', '手数', '持仓价', '平仓价', '止盈价', '止损价', '保证金', '可用保证金', '开仓时间', '平仓时间', '手续费',
      '盈亏', '操作'
    ],
    lt_4_txt: ['已撤单'],
    cm: ['发行时间', '发行总量', '流通总量', '总凑价格', '官网', '白皮书', '介绍'],
    qsrsl: '请输入数量',
    qsrss: '请输入手数',
  },
  notice: {
    notice_title: '公告中心',
  },
  bzhl: {
    title: '持仓返利',
    ttzbt: '天天赚不停',
    wdtg: '我的托管',
    zztgdzj: '正在托管的资金',
    yjjrsy: '预估日收益',
    ljsy: '累计收益',
    tgzdd: '托管中订单',
    tgdd: '托管订单',
    t1: '低风险稳健理财，有需要可随时赎回',
    t2: '您的闲钱管理小助手',
    cljxcp: '产品周期',
    dbxe: '单笔限额',
    rsyl: '收益率(%)',
    rsyl2: '日收益率：',
    zq: '周期',
    qmr: '去买入',
    ckgd: '查看更多',
    cpgk: '产品概况',
    pxsj: '派息时间',
    tgzj: '托管资金',
    tqsh: '提取赎回',
    cpld: '产品亮点',
    cpgz: '产品规则',
    cont: '搬砖是通过将USDT托管给平台，由平台的专业团队进行搬砖权利，参与者在资金托管期间可获得平台的搬砖收入分成，可随时存取，安全又便捷。',
    zj: '100%资金',
    aqbz: '安全保障',
    jjrsy: '节假日收益',
    bjd: '不间断',
    cgcrh: '成功存入后',
    dtqx: '当天起息',
    ljzr: '立即转入',
    xqglgj: '闲钱管理工具',
    ddh: '订单号',
    tgje: '托管金额',
    tgsj: '周期天数',
    yhl: '已获利/剩余天数',
    xdsj: '下单时间',
    zt: '状态',
    fh: '返回',
    qrnhsy: '七日年化收益',
    ygy: '1个月',
    bn: '半年',
    yn: '1年',
    yuan: '元',
    tzfx: '投资风险',
    shsc: '赎回时长',
    di: '低',
    yggzr: '一个工作日',
    msgsxf: '免申购手续费',
    mr: '每日',
    dqfh: '到期返还',
    ljgm: '立即购买',
    tgz: '托管中',
    sh: '赎回',
    ywc: '已完成',
    ysh: '已赎回',
    all: '全部',
    "xzbzts": "简单，安全。可选择多种币种进行派息",
    "qtbz": "其它币种"
  },
  pay: {
    qsrjymm: '请输入6位交易密码',
    tbmmts: '请到用户中心设置交易密码',
  },
  tips: {
    qxztbdz: '请输入提币地址',
    qsrtbsl: '请输入提币数量'
  },
  statusText: ['失败', '等待处理', '成功'],
  dzrz: {
    title: '地址认证',
    sdddz: '水电单地址',
    zdtpsc: '账单图片上传',
    qsrsdddz: '您需要填写地址信息和提交水电费或者宽带地址的账单',
    qsczdtp: '请上传账单图片',
    status: ['审核中', '审核通过'],
    qd: '确定',
  },
  jgcc: {
    wtgd: '委托挂单',
    cj: '成交',
    jj: '简介',
    zc: '在持',
    lszc: '历史持仓',
    qblx: '全部类型',
    xj: '现价',
    sj: '时间',
    fx: '方向',
    jg: '价格',
    sl: '数量',
    jgsj: '交割时间',
    gmj: '购买价',
    jsj: '结算价',
    yk: '盈亏',
    xq: '详情',
    mz: '买涨',
    md: '买跌',
    dqye: '当前余额',
    gb: '关闭',
    jxxd: '继续下单',
    qrxd: '确认下单',
    ddqr: '订单确认',
    sxf: '手续费',
    kyye: '可用余额',
    jypz: '名称',
    jyfx: '交易方向',
    tzje: '投资金额',
    tzjeTips: '投资金额不能为0',
    dqsj: '到期时间',
    jssj: '结算时间',
    gmsj: '购买时间',
    sy: '收益',
    zxje: '最小数量 ',
    shi: '时',
    fen: '分',
    miao: '秒',
    zdje: '最大数量 ',
    qsrje: '请输入金额',
    zxtzje: '最低数量 ',
    yebz: '余额不足',
    xq: '详情',
    ddz: '等待中',
    jgjl: '交割记录',
    bz: '币种',
    cz: '操作'
  },
  kjmb: {
    title: '快捷买币',
    fzcg: '复制成功',
    ljmb: '立即买币',
    lxkf: '联系客服'
  },
  news: {
    title: '我的消息',
    "gg": "公告",
    ckxq: '查看详情'
  },
  statusTabs: ['挂单中', '交易中', '已平仓', '已撤单'],
  "chongzhi": {
    "zy": "注意",
    "tips2": "1.钱包/平台的兼容：即对该网络支持；如目标平台不支持您的提币网络，将导致资产无法找回。",
    "tips3": "2.您充值网络和目标平台是一致的；如您选择了目标地址是以太坊网络，但充值选择了TRC20智能链，您或将无法找回您的数字资产。",
    "tips4": "3.充值前确保您的地址、金额正确。",
    "tips5": "温馨提示：由于区块网络匿名和私密，一旦输入错误信息，您将损失对应资产。请务必仔细核对您的充值地址及数量",
    "cbxx": "充币信息",
    "qsrsl": "请输入充币数量",
    "tips2_1": "• 请勿向上述地址充任何非本币种资产，否则资产不可找回。",
    "tips2_2": "• 数字货币无法及时到账，实际到账时间取决于区块链确认速度。",
    "tips2_3": "• 您的充值地址不会经常改变，可以重复充值；如有更改，我们会尽量通过网站公告或邮件通知您。",
  },
  "tibi": {
    "tbxx": "提币信息",
    "qsrbq": "请输入标签",
    "tbTips1": "• 为保障资金安全，当您账户安全策略变更、密码修改、我们会对提币进行人工审核，请耐心等待工作人员电话或邮件联系。",
    "tbTips2": "• 请务必确认电脑及浏览器安全，防止信息被篡改或泄露。",
    "tbTips3": "• 您所提的数字资产为一币多链资产，无论您选择从哪个链上提出，均意味著您所拥有的该提币页面展示的数字资产总量减少相应的提出数量。",
  },
  "gjlb": "国家列表",
  "qxzgjlb": "请选择国家/地区",
  "mbwt": {
    "title": "密保问题设置",
    "mbwt": "密保问题",
    "problem": [{
        "id": 1,
        "title": "您小时候最好的朋友是？"
      },
      {
        "id": 2,
        "title": "您的偶像是？"
      },
      {
        "id": 3,
        "title": "您最向往的地方是哪里？"
      }
    ],
    "qtxda": "请填写答案",
    "qsrxmm": "请输入新密码",
    "qqrmm": "请确认密码",
    "sydqmmcz": "使用当前密码重置",
    "zhmm": "密保问题找回密码",
    "ysz": "已设置",
    "tg": "跳过",
    "tj": "提交",
    "zyts": "重要提示：",
    "zytsCont": "请勿泄露密保答案和验证码，并牢记密保问题，这将有助于您找回密码"
  },
  "zc": {
    "zclb": "资产列表",
    "zczh": "资产折合",
    "yczc": "隐藏为0的资产"
  },
  "indexNew": {
    "t1": "全球领先的",
    "t2": "数字资产服务平台",
    "t3": "完整的一站式区块链数字资产交易",
    "t4": "手机号/邮箱",
    "t5": "立即注册",
    "t6": "欢迎世界各地的客户通过 GMO Global",
    "t7": "发现并开始他们的加密之旅"
  },
  "newReg": {
    "dl": ['邮箱', '手机'],
    "cjzh": "创建账户",
    "sysjhzyx": "使用手机号/电子邮箱注册",
    "yhxy": "《用户协议》",
    "yhxy2": "我已阅读并同意《用户协议》",
    "yxgz": "输入的邮箱不符合规则",
    "dhgz": "输入的手机号码格式有误"
  },
  "indexNew2": {
    "t1": "在我们的订单上交易",
    "t2": "使用比特银行",
    "t3": "比特银行是一种设计巧妙的比特币和加密资产交换，非常简单、方便、安全且功能强大。在多个web和智能手机平台上支持交易。交易数据和图表实时更新，为全面    市场价格分析提供60多种技术分析工具。开始交易",
    "ksjy": "开始交易",
    "ly": "选择Bitbank的5个理由",
    "item1_t1": "交易量领先",
    "item1_t2": "No.1 * 加密资产交易量",
    "item1_t3": "高流动性，舒适（愉快的交易体验）交易。列出 12 种加密资产。",
    "item2_t1": "第三方评价高",
    "item2_t2": "安全的交易环境",
    "item2_t3": "采用离线冷钱包。通过 Multisig 将黑客拒之门外。以高科技保护您的资产",
    "item3_t1": "易于使用且可靠的应用程序",
    "item3_t2": "易用简便的应用程序",
    "item3_t3": "具有丰富功能的可靠应用程序。可在外交易保持交易机会。",
    "item4_t1": "全日无休",
    "item4_t2": "可入金",
    "item4_t3": "24 小时存款支持，包括假期！",
    "item5_t1": "智能手机和PC",
    "item5_t2": "人性化设计",
    "item5_t3": "即使使用智能手机也可以毫不犹豫地进行简单合格的交易",
    "aqkk": "安全可靠",
    "aqkk2": "比特银行的比特币交易",
    "cjzh": "创建一个账户",
  },
  "xbsg": {
    "title": "新币申购",
    "wdsg": "我的申购",
    "scts": "锁仓天数：",
    "sy": "剩余",
    "ljsg": "立即申购",
    "ysk": "已售空",
    "xzjdy": "现在就订阅",
    "dy": "订阅",
    "fxjg": "发行价格",
    "fxl": "发行量",
    "ssrq": "上市日期",
    "yxqx": "有效期限",
    "qsrsl": "请输入数量",
    "syl": "剩余量",
    "sgrq": "申购日期",
    "sgsl": "申购数量",
    "bz": "币种",
    "yebz": "USDT余额不足",
    "tgsl": "通过数量",
    "shz": "审核中",
    "wtg": "未通过",
    "ytg": "已通过"
  },
  "wydb": {
    "title": "我要贷币",
    "db": "贷币",
    "dbz": "贷币中",
    "jl": "记录",
    "jdzq": "借贷周期(天)",
    "qhk": "去还款",
    "ljdb": "累计贷币(usdt)",
    "dhkbs": "待还款笔数",
    "jkje": "借款金额(usdt)",
    "qsrje": "请输入金额",
    "rll": "日利率",
    "hkfs": "还款方式",
    "dqych": "到期一次还本息",
    "lx": "利息",
    "fkjg": "放款机构",
    "tpsc": "信用贷款(图片上传)",
    "fwxx": "房屋信息",
    "srzm": "收入证明(雇佣关系)",
    "yhmx": "银行明细",
    "zjz": "证件照",
    "yd": "本人已阅读并同意",
    "xy": "申请贷币协议",
    "sqdb": "点击申请贷币",
    "gb": "关闭",
    "qd": "确定",
    "ts": "请勾选申请贷币协议",
    "dbjl": "贷币记录",
    "hkhth": "贷款合同号",
    "wsh": "未审核",
    "yfk": "已放款",
    "sqrq": "申请日期",
    "zq": "周期",
    "dbsl": "贷币数量",
    "zhke": "总还款额",
    "yhkxq": "应还款详情",
    "bqyhk": "本期应还款（USDT）",
    "hktips": "请确保余额充足，余额不足请先充值再还款",
    "bj": "本金",
    "jie": "借",
    "ljhk": "立即还款",
    "qcz": "去充值",
    "yebzqxcz": "余额不足，请先充值再还款",
    "znj": "滞纳金",
    "yqts": "逾期天数"
  },
  "hkxq": {
    "dd": "订单",
    "fzhkdz": "复制还款地址",
    "hkxq": "还款详情",
    "zlx": "总利息",
    "zhk": "总还款",
    "hkjg": "还款机构",
    "qschkpz": "请上传还款凭证",
    "hkpz": "还款凭证"
  },
  "bbjyNew": {
    "jylx": "交易类型",
    "jyze": "交易总额"
  },
  "bind": {
    "title": "邮箱认证",
    "ybd": "已绑定",
    "wbd": "未绑定",
    "ts": "为保护您的账户，建议绑定邮箱",
    "qsryxdz": "请输入邮箱地址"
  },
  "tipsNew": {
    "yjj": "已拒绝",
    "shz": "赎回中"
  },
  "newIndex2": {
    "zxhy": "最新行情",
    "jypt": "交易平台",
    "dqwz": "当前位置",
    "yzm": "验证码",
    "qrmm": "确认密码",
    "djdl": "点击登录",
    "ghdjy": "更好的交易",
    "ghdsh": "更好的生活",
    "about": "世界上最具创新性的加密交易中心就在这里，您可以购买、交易和赚取加密货币，触手可及的加密货币多达数百种。",
    "index01": "您通往比特币及其他领域的门户",
    "index02": "全球领先的数字资产服务平台",
    "index03": "各种交易都是免费的",
    "index04": "开户费、账户维护费、止损费、押金费、仓储/送货费全部免费。",
    "index05": "安全可靠的安保",
    "index06": "利用 GMI INT 自成立以来积累的专业知识，我们正在构建强大的系统并实施各种安全措施，以安全可靠地保护客户的资产。",
    "index07": "实物交易和杠杆交易均可用",
    "index08": "小额交易可以从10美元左右进行，点差是业内最窄的，可以以账户余额作为抵押进行杠杆交易，只有GMI INT可以收取杠杆费用。",
    "index09": "旨在增强GMI INT社区能力的代币",
    "index10": "Unus Sed LEO为应用型代币，旨在协助寻求GMI INT交易平台最大化效益及功能的用户符合其需求。",
    "index11": "旨在增强GMI INT社区能力的代币",
    "index12": "开启通往美好生活的道路",
    "index13": "每个人都可以拥有加密。每个人都可以交易加密软件。以下是Bitget如何让您更进一步。",
    "index14": "创新产品",
    "index15": "一键复制交易",
    "index16": "交易时不转换代币",
    "index17": "支持USDC保证金的主要衍生品交易所",
    "index18": "通过冷热钱包隔离进行风险控制",
    "index19": "12 a+来自SSL实验室的评级",
    "index20": "受Suntwin技术、青松云安全、HEAP和Armors支持的可信安全",
    "index21": "卓越的客户服务",
    "index22": "全天候多语言在线支持",
    "index23": "对VIP客户的一对一支持",
    "index24": "社区奖励中心",
    "index25": "由交易者为交易者建造",
    "index26": "以低交易成本交易各种数字资产，如比特币、以太坊、Solana 和 dogcoin",
    "index27": "您购买、出售、交易、投资和使用加密货币所需的工具和信息",
    "index28": "业界领先的安全性",
  },
  "langNew": {
    "gdjy": "挂单交易",
    "szhb": "数字货币",
    "gjs": "贵金属",
    "yy": "原油",
    "jy": "交易",
    "jmhb": "加密货币",
    "yxhy": "永续合约",
    "khh": "开户行",
    "qsrkhh": "请输入开户行",
    "yhkh": "银行卡号",
    "qsryhkh": "请输入银行卡号",
    "mnzh":"模拟账户",
    "cjmnzhcg":"模拟账户创建成功",
    "tcmnzh":"退出模拟账户",
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js